import { render, staticRenderFns } from "./initiateScoringTask.vue?vue&type=template&id=93accb4e&scoped=true"
import script from "./initiateScoringTask.vue?vue&type=script&lang=js"
export * from "./initiateScoringTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93accb4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93accb4e')) {
      api.createRecord('93accb4e', component.options)
    } else {
      api.reload('93accb4e', component.options)
    }
    module.hot.accept("./initiateScoringTask.vue?vue&type=template&id=93accb4e&scoped=true", function () {
      api.rerender('93accb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/AAA/initiateScoringTask.vue"
export default component.exports